export const BRAND_NAME = 'PromptGPT';
export const BRAND_TAGLINE = 'Learn AI as a skill — at any age, any level.';
